export const SHOPPING_LIST_ITEM_STATUS = {
  ACTIVE: 'is-active',
  COMPLETED: 'is-completed',
  NOT_PROCESSED: 'is-unprocessed'
}
